module.exports = __webpack_public_path__ + "img/org05.c3f9cdc4.png";